module.exports = __webpack_public_path__ + "img/pro_bannerbg@2x.49e16a0b.jpg";